import { Grid as MuiGrid } from '@mui/material';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { memo, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { GridContainer } from '~/components/GridContainer';
import { EmptyState } from '~/components/empty-state';
import ActivateDeviceIllustration from '~/images/illustrations/activate-device.svg';
import type { DeviceList__Device as Device } from '../../queries/list.generated';
import { GridRow } from './';

export interface GridProps {
  devices: readonly Device[];
  loading?: boolean;
  onCheck: Dispatch<SetStateAction<GridRowSelectionModel>>;
  selectedIds: GridRowSelectionModel;
}

export const Grid = memo(({ devices, loading, onCheck, selectedIds }: GridProps) => {
  const { t } = useTranslation();

  return (
    <GridContainer
      loading={loading}
      isEmpty={devices.length === 0}
      emptyState={
        <EmptyState
          illustration={ActivateDeviceIllustration}
          header={t('pages.devices.empty_state.header')}
          description={t('pages.devices.empty_state.description')}
        />
      }
    >
      <MuiGrid container spacing={2}>
        {devices.map((device) => (
          <GridRow key={device.id} item={device} onCheck={onCheck} selectedIds={selectedIds} />
        ))}
      </MuiGrid>
    </GridContainer>
  );
});

Grid.displayName = 'Grid';
